var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.$modal.close(_vm.target)}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}
var staticRenderFns = []

export { render, staticRenderFns }